import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Testimonios() {
  return <section id="testimonios" className="py-20 md:py-28 bg-gray-50" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-navy-900 mb-4" data-id="element-216">
            Lo que dicen los <span className="text-gold-600" data-id="element-217">docentes</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-218">
            Cientos de profesores ya transformaron su forma de enseñar
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid md:grid-cols-3 gap-8" data-id="element-219">
          {/* Testimonial 1 */}
          <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 relative" data-id="element-220">
            <QuoteIcon className="h-10 w-10 text-gold-200 absolute top-6 right-6" data-id="element-221" />
            <div className="flex gap-1 mb-4" data-id="element-222">
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-223" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-224" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-225" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-226" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-227" />
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-228">
              "Las secuencias de lectoescritura son mágicas. Mis alumnos
              avanzaron en un mes lo que no habían avanzado en todo el trimestre
              anterior. ¡Gracias!"
            </p>
            <div className="flex items-center gap-4" data-id="element-229">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-lg" data-id="element-230">
                C
              </div>
              <div data-id="element-231">
                <p className="font-bold text-navy-900" data-id="element-232">Carla M.</p>
                <p className="text-sm text-gray-500" data-id="element-233">Docente de 4to Grado</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 relative" data-id="element-234">
            <QuoteIcon className="h-10 w-10 text-gold-200 absolute top-6 right-6" data-id="element-235" />
            <div className="flex gap-1 mb-4" data-id="element-236">
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-237" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-238" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-239" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-240" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-241" />
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-242">
              "Por fin un material de secundaria que no aburre a los chicos. Las
              guías de análisis literario son modernas y fáciles de seguir. Me
              ahorró semanas de trabajo."
            </p>
            <div className="flex items-center gap-4" data-id="element-243">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg" data-id="element-244">
                R
              </div>
              <div data-id="element-245">
                <p className="font-bold text-navy-900" data-id="element-246">Ricardo J.</p>
                <p className="text-sm text-gray-500" data-id="element-247">Profesor de Literatura</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 3 */}
          <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 relative" data-id="element-248">
            <QuoteIcon className="h-10 w-10 text-gold-200 absolute top-6 right-6" data-id="element-249" />
            <div className="flex gap-1 mb-4" data-id="element-250">
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-251" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-252" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-253" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-254" />
              <StarIcon className="h-5 w-5 text-gold-500 fill-gold-500" data-id="element-255" />
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-256">
              "Lo compramos para la biblioteca docente y es la mejor inversión
              que hicimos. Todos los profes lo usan como base para sus clases."
            </p>
            <div className="flex items-center gap-4" data-id="element-257">
              <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white font-bold text-lg" data-id="element-258">
                E
              </div>
              <div data-id="element-259">
                <p className="font-bold text-navy-900" data-id="element-260">Estela S.</p>
                <p className="text-sm text-gray-500" data-id="element-261">Directora de Escuela</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}